<template>
    <div class="strategies">

      <table class="strategies-table">
        <thead>
          <!-- <tr>
            <th colspan="2">DEFINIMOS 1 O 2 ESTRATEGIAS PARA APOYO A LAS 2 PRIORIDADES ESTRATEGICAS MÁS RELEVANTES</th>

          </tr> -->
          <tr>
            <th>
              {{ $t('marketing.strategies.priority.1') }}
              <span class="name">{{objectivesParsed[0].name}}</span>
            </th>
            <th>{{ $t('marketing.strategies.priority.2') }}
              <span class="name">{{objectivesParsed[1].name}}</span>
              </th>
            <th>{{ $t('marketing.strategies.priority.3') }}
              <span class="name">{{objectivesParsed[2].name}}</span>
              </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div v-if="true">
                <span class="cell-title">{{ $t('marketing.strategies.title.a') }}</span>
                <v-container class="select-editable" v-if="parseInt(objectivesParsed[0].type) == 2">
                  <v-textarea auto-grow height=auto class="text" rows="1" hide-details color=black row-height=20px v-model="strategiesTableData[0][1].strategy_name" v-if="objectivesParsed[0].name != null" spellcheck="false" @input="changeOption();">
                  </v-textarea>
                </v-container>
                <v-container class="select-editable" v-else>
                  <v-select
                    v-if="objectivesParsed[0].name != null"
                    :items="Object.values(categories[strategiesTableData[0][1].objective_id].childs)"
                    v-model="strategiesTableData[0][1].section_id"
                    item-text="name"
                    item-value="id"
                    @change="changeOption();"
                  ></v-select>
                </v-container>
              </div>
            </td>
            <td>
              <div v-if="true">
                <span class="cell-title">{{ $t('marketing.strategies.title.c') }}</span>
                <v-container class="select-editable" v-if="parseInt(objectivesParsed[1].type) == 2">
                  <v-textarea auto-grow height=auto class="text" rows="1" hide-details color=black row-height=20px v-model="strategiesTableData[0][3].strategy_name" v-if="objectivesParsed[1].name != null" spellcheck="false" @input="changeOption();">
                  </v-textarea>
                </v-container>
                <v-container class="select-editable" v-else>
                  <v-select
                    v-if="objectivesParsed[1].name != null"
                    :items="Object.values(categories[strategiesTableData[0][3].objective_id].childs)"
                    v-model="strategiesTableData[0][3].section_id"
                    item-text="name"
                    item-value="id"
                    @change="changeOption();"
                  ></v-select>
                </v-container>
              </div>
            </td>
            <td>
              <div v-if="true">
                <span class="cell-title">{{ $t('marketing.strategies.title.e') }}</span>
                <v-container class="select-editable" v-if="parseInt(objectivesParsed[2].type) == 2">
                  <v-textarea auto-grow height=auto class="text" rows="1" hide-details color=black row-height=20px v-model="strategiesTableData[0][5].strategy_name" v-if="objectivesParsed[2].name != null" spellcheck="false" @input="changeOption();">  
                  </v-textarea>
                </v-container>
                <v-container class="select-editable" v-else>
                  <v-select
                    v-if="objectivesParsed[2].name != null"
                    :items="Object.values(categories[strategiesTableData[0][5].objective_id].childs)"
                    v-model="strategiesTableData[0][5].section_id"
                    item-text="name"
                    item-value="id"
                    @change="changeOption();"
                  ></v-select>
                </v-container>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div v-if="true">
                <span class="cell-title">{{ $t('marketing.strategies.title.b') }}</span>
                <v-container class="select-editable" v-if="parseInt(objectivesParsed[0].type) == 2">
                  <v-textarea auto-grow height=auto class="text" rows="1" hide-details color=black row-height=20px v-model="strategiesTableData[0][2].strategy_name" v-if="objectivesParsed[0].name != null" spellcheck="false" @input="changeOption();">
                  </v-textarea>
                </v-container>
                <v-container class="select-editable" v-else>
                  <v-select
                    v-if="objectivesParsed[0].name != null"
                    :items="Object.values(categories[strategiesTableData[0][2].objective_id].childs)"
                    v-model="strategiesTableData[0][2].section_id"
                    item-text="name"
                    item-value="id"
                    @change="changeOption();"
                  ></v-select>
                </v-container>
              </div>
            </td>
            <td>
              <div v-if="true">
                <span class="cell-title">{{ $t('marketing.strategies.title.d') }}</span>
                <v-container class="select-editable" v-if="parseInt(objectivesParsed[1].type) == 2">
                  <v-textarea auto-grow height=auto class="text" rows="1" hide-details color=black row-height=20px v-model="strategiesTableData[0][4].strategy_name" v-if="objectivesParsed[1].name != null" spellcheck="false" @input="changeOption();">
                  </v-textarea>
                </v-container>
                <v-container class="select-editable" v-else>
                  <v-select
                    v-if="objectivesParsed[1].name != null"
                    :items="Object.values(categories[strategiesTableData[0][4].objective_id].childs)"
                    v-model="strategiesTableData[0][4].section_id"
                    item-text="name"
                    item-value="id"
                    @change="changeOption();"
                  ></v-select>
                </v-container>
              </div>
            </td>
            <td>
              <div v-if="true">
                <span class="cell-title">{{ $t('marketing.strategies.title.f') }}</span>
                <v-container class="select-editable" v-if="parseInt(objectivesParsed[2].type) == 2">
                  <v-textarea auto-grow height=auto class="text" rows="1" hide-details color=black row-height=20px v-model="strategiesTableData[0][6].strategy_name" v-if="objectivesParsed[2].name != null" spellcheck="false" @input="changeOption();">
                  </v-textarea>
                </v-container>
                <v-container class="select-editable" v-else>
                  <v-select
                    v-if="objectivesParsed[2].name != null"
                    :items="Object.values(categories[strategiesTableData[0][6].objective_id].childs)"
                    v-model="strategiesTableData[0][6].section_id"
                    item-text="name"
                    item-value="id"
                    @change="changeOption();"
                  ></v-select>
                </v-container>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div :class="{'hidden': !change}" @click="save()" class="save no-print">
        {{ $t('general.save') }}
      </div>

    </div>
</template>

<script>

export default {
  props: {categories: Object, strategies: Array},
  data () {
    return {
      change: false,

      strategiesTableData: [
        {1: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 1}, 
        2: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 2},
        3: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 3},
        4: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 4},
        5: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 5},
        6: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 6}},
      ],

      objectivesParsed: [{name: null}, {name: null}, {name: null}],

      emptyStrategiesTableData: [
        {1: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 1}, 
        2: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 2},
        3: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 3},
        4: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 4},
        5: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 5},
        6: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 6}},
      ],
      
    }
  },
  computed: {
    strategiesParsed() {
      var filled = false;
      this.objectivesParsed = [{name: null}, {name: null}, {name: null}];
      if (this.strategies[0] != undefined){
        // Vars to detect the change of the objective
        this.strategiesTableData = [
        {1: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 1}, 
        2: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 2},
        3: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 3},
        4: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 4},
        5: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 5},
        6: {resobjective_id: null, objective_id: null, section_id: null, strategy_name: null, status: 6}},
      ];
        for ( var index in this.strategies ) {
          var item = this.strategies[index];
          console.log(item);
          // Set objective_id for each strategy gap
          if (item.status!= null) {
            this.objectivesParsed[item.status-1].name = item.name;
            this.objectivesParsed[item.status-1].type = item.type;
            switch ( item.status-1 ) {
              case 0:
                this.strategiesTableData[0][1].objective_id = item.id;
                this.strategiesTableData[0][1].resobjective_id = item.resobjective_id;
                this.strategiesTableData[0][1].type = item.type;
                this.strategiesTableData[0][2].objective_id = item.id;
                this.strategiesTableData[0][2].resobjective_id = item.resobjective_id;
                this.strategiesTableData[0][2].type = item.type;
                break;
              case 1:
                this.strategiesTableData[0][3].objective_id = item.id;
                this.strategiesTableData[0][3].resobjective_id = item.resobjective_id;
                this.strategiesTableData[0][4].objective_id = item.id;
                this.strategiesTableData[0][4].resobjective_id = item.resobjective_id;
                break;
              case 2:
                this.strategiesTableData[0][5].objective_id = item.id;
                this.strategiesTableData[0][5].resobjective_id = item.resobjective_id;
                this.strategiesTableData[0][6].objective_id = item.id;
                this.strategiesTableData[0][6].resobjective_id = item.resobjective_id;
                break;
            }
            // Changing the objective to asign
          }

          // Fill the gaps of strategy setting the section_id
          for ( var subindex in item.strategies ) {
            // If is Category local
            console.log(parseInt(item.type));
            if (parseInt(item.type) == 2) {
              this.strategiesTableData[0][parseInt(item.strategies[subindex].status)].strategy_name = item.strategies[subindex].strategy_name;
            }
            else {
              this.strategiesTableData[0][parseInt(item.strategies[subindex].status)].section_id = item.strategies[subindex].section_id;
            }
            filled = true;
            this.strategiesTableData[0][parseInt(item.strategies[subindex].status)].status = item.strategies[subindex].status;
            this.strategiesTableData[0][parseInt(item.strategies[subindex].status)].objective_id = item.id;
          }
        }
      }
      else {
        // If there is not data avaiable, set empty Array
        return this.strategiesTableData = [...this.emptyStrategiesTableData];
      }
    },

    // categories() {
    //   return this.$store.getters['files/getCategories'](this.type);
    // },

    selectedLocation () {
      return this.restaurant = this.$store.getters['locations/getSelectedLocation'];
    },

    selectedYear(){
      return this.$parent.selectedYear;
    },

    strategiesOptions(){
      return Object.values(this.$store.getters['locations/getStrategies']);
    },
  },
  methods: {
    save() {
      var aData = {};
      aData.tableData = JSON.stringify(this.strategiesTableData);
      aData.restaurant_id = this.$store.getters['locations/getSelectedLocation'].id;
      aData.year = this.selectedYear;
      var self = this;
      this.$store.dispatch( 'locations/updateStrategies', aData ).then(function(){
        self.change = false;
        self.$store.dispatch('locations/loadMarketing', {restaurant_id: self.$store.getters['locations/getSelectedLocation'].id, year: self.selectedYear} )
      });
    },

    changeOption() {
      this.change = true;
    },

  },
  watch: {
    selectedLocation () {
      if (this.selectedLocation==undefined){
        this.$store.getters['locations/getSelectedLocation'];
      }
      this.$store.dispatch('locations/loadCompetence', this.$store.getters['locations/getSelectedLocation'].id );
     },

    selectedYear () {
      this.$store.dispatch('locations/loadStrategies', this.selectedYear);
      this.strategiesTableData = [...this.emptyStrategiesTableData];
    },

    strategies () {
      this.strategiesTableData = [...this.emptyStrategiesTableData];
      this.strategiesParsed;
      this.change = false;
    },

  },
  created() {
    var self = this;
    this.$store.dispatch('locations/loadStrategies', this.selectedYear).then(function(){
      // self.$store.dispatch('files/loadCategories', {type: undefined});
      self.strategiesParsed;
    });
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


  /* TABLE */

  .strategies-table {
    margin: 20px auto 0px;
    border-color: white;
    width: 80%;

    &.weekend {
      margin-top: 40px;
    }

    .hide {
      visibility: hidden !important;
      opacity: 0 !important;
    }

    thead {

      tr {

        th {
          width: 33%;
          background-color: transparent;
          border-bottom: 1px solid var(--main_color);
          height: 50px;
          text-transform: uppercase;
          padding: 10px 10px;

          .name {
            display: block;
          }
        }
      }
    }

    tbody {
      //background-color: var(--main_color);
    }

    tr {
      //background-color: rgba(255,255,255,0.5);
      height: 60px;
    }

    tr:nth-child(odd) {
      //
    }

    td {
      text-transform: uppercase;
      font-weight: bold;
      padding: 5px 20px;
      text-align: center;
      background-color: rgba(255,255,255,0.7);

      .cell-title {
        display: block;
        text-align: left;
      }

      .select-editable {
        width: 100%;
        margin: 0px;
        padding: 0px;

        .text {
          padding-top: 0px;
          background-color: white;
        }
      }
    }
  }

  .save {
    background-color: #8bc34a;
    width: fit-content;
    margin: 0 auto;
    margin-top: 30px;
    color: white;
    padding: 8px 25px;
    border-radius: 3px;
    font-size: 16px;
    cursor: pointer;
    opacity: 1;
    transition: 0.5s;
    text-transform: uppercase;

    &.hidden {
      display: none;
      opacity: 0;
      height: 0px;
      transition: 0.5s;
    }

  }

</style>
